/** Mathe- und DOM-Hilfsfunktionen. */

export const clamp = (v, a, b) => Math.max(a, Math.min(b, v))
export const smooth = (a, b, t) => a + (b - a) * t
export const $ = (id) => document.getElementById(id)

/** Einfacher Logger – ersetzt die alten alert()/stillen catch-Blöcke. */
export const log = {
  warn: (...a) => console.warn('[REVX]', ...a),
  error: (...a) => console.error('[REVX]', ...a),
}

/**
 * Zeigt eine kurze, nicht blockierende Statusmeldung im Header an.
 * Fällt auf console zurück, falls das DOM noch nicht bereit ist.
 */
export function toast(main, sub) {
  const m = $('stMain'),
    s = $('stSub')
  if (m) m.textContent = main
  if (s && sub != null) s.textContent = sub
  if (!m) log.warn(main, sub ?? '')
}
